import { useNavigate } from 'react-router-dom';
import { Card, PageHeader, Pill, Stat } from '@/components/ui';
import { Icon, I } from '@/components/icons';
import { useAlerts, type AlertSeverity } from '@/lib/useAlerts';

const TONE: Record<AlertSeverity, { bg: string; color: string; label: string }> = {
  danger: { bg: 'var(--danger-bg)', color: 'var(--danger)', label: '緊急' },
  warn: { bg: 'var(--warn-bg)', color: 'var(--warn)', label: '注意' },
  info: { bg: 'var(--surface-2)', color: 'var(--ink-2)', label: '提示' },
};

export function NotificationsPage() {
  const nav = useNavigate();
  const { items, total } = useAlerts();

  return (
    <div>
      <PageHeader title="通知中心" subtitle="由系統現況即時推導的站內通知 · 點擊前往對應頁面處理" />

      <div style={{ display: 'flex', gap: 14, marginBottom: 16 }}>
        <Stat label="待處理通知" value={String(total)} tone={total > 0 ? 'warn' : 'success'} />
        <Stat label="緊急" value={String(items.filter((i) => i.severity === 'danger').length)} tone="danger" />
        <Stat label="注意" value={String(items.filter((i) => i.severity === 'warn').length)} tone="warn" />
      </div>

      <Card title="通知列表" icon={<Icon d={I.bell} size={14} style={{ color: 'var(--primary)' }} />}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {items.map((a) => {
            const t = TONE[a.severity];
            return (
              <button key={a.id} onClick={() => nav(a.to)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 12px', borderRadius: 8, border: '1px solid var(--line)', background: 'var(--surface)', cursor: 'pointer', textAlign: 'left' }}>
                <Pill bg={t.bg} color={t.color}>{t.label}</Pill>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>{a.title}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--ink-3)' }}>{a.detail}</div>
                </div>
                <Icon d={I.arrow} size={14} style={{ color: 'var(--ink-4)' }} />
              </button>
            );
          })}
          {total === 0 && <div style={{ padding: 20, textAlign: 'center', color: 'var(--ink-4)', fontSize: 13 }}>目前沒有待處理通知 🎉</div>}
        </div>
      </Card>
    </div>
  );
}
